<template>
  <div class="projects">
    <h2 class="ui header" v-if="header">
      <i class="folder grey icon" />
      <sui-header-content>{{header}}</sui-header-content>
    </h2>
    <transition-group class="ui cards" name="card">
      <sui-card class="card-item" key="new">
        <sui-button-group class="fluid content" basic vertical size="huge">
          <sui-button class="ui left labeled icon button" :class="{disabled: !access.projectCreate}" data-goal="PROJECT_CARDS_CREATE" @click="openProjectCreator()">
            <i class="orange folder icon" />
            Create project
          </sui-button>
          <router-link class="ui left labeled icon button" to="/new-stack" :class="{disabled: !access.serviceCreate}">
            <i class="green briefcase icon" />
            New stack
          </router-link>
        </sui-button-group>
      </sui-card>
      <ProjectCard class="card-item" :project="project" v-for="project in projects" :key="project.id"/>
    </transition-group>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ProjectCard from './Project'

  export default {
    name: 'ProjectCards',
    components: {
      ProjectCard,
    },
    props: {
      header: {
        type: String,
        required: false,
        default: 'Projects',
      },
      projects: {
        type: Array,
        required: false,
        default() {
          return this.$store.getters.projects
        },
      },
    },
    computed: {
      ...mapGetters(['access']),
    },
    methods: {
      openProjectCreator() {
        this.$modals.createProject.open()
      },
    }
  }
</script>

<style scoped>
  .ui.card > .content { display: flex; flex-grow: 1!important; padding: 0!important; }
  .ui.buttons { margin: 0!important; width: auto!important; }
  .ui.buttons .ui.button { flex: 1; min-height: 3.8em; justify-content: flex-start!important; align-items: center!important; padding-left: 4em!important; white-space: nowrap; }
  .ui.buttons .ui.button:hover { background-color: #eee; box-shadow: none!important; }
  .ui.buttons .ui.button >>> .icon { display: flex; align-items: center; font-size: 1.3em; }
</style>
